enum AssociationStatuses {
  DEFAULT,
  FOLLOWED,
  ASSIGNED,
}

export default AssociationStatuses
